import { render, staticRenderFns } from "./DocumentRegisterSummary.vue?vue&type=template&id=62246a7e&scoped=true&"
import script from "./DocumentRegisterSummary.vue?vue&type=script&lang=js&"
export * from "./DocumentRegisterSummary.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRegisterSummary.vue?vue&type=style&index=0&id=62246a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62246a7e",
  null
  
)

export default component.exports